module.exports = __webpack_public_path__ + "static/media/right_double_arrow.6f90f655.svg";